import { MAX_PAYLOAD_SIZE } from './encryption';
import { MESSAGE_HEADER_SIZE } from './dataFrame';

// === Chunk Metadata Field Sizes (in bytes) ===

// Protocol version identifier (e.g., 1)
export const CHUNK_VERSION_LENGTH = 1;

// Message identifier shared by all chunks belonging to the same message
export const CHUNK_MESSAGE_ID_LENGTH = 8;

// Index of this chunk within the message (0-based)
export const CHUNK_INDEX_LENGTH = 2;

// Total number of chunks for the full message
export const CHUNK_TOTAL_COUNT_LENGTH = 2;

// Type of message: 0 = text, 1 = file, etc. (0–127 reserved, 128+ custom)
export const CHUNK_MESSAGE_TYPE_LENGTH = 1;

// Optional client identifier to assist with custom type routing and filtering
export const CHUNK_CLIENT_ID_LENGTH = 8;

// === Derived Constants ===

// Total size of all chunk metadata headers
export const CHUNK_METADATA_HEADER_SIZE =
  CHUNK_VERSION_LENGTH +
  CHUNK_MESSAGE_ID_LENGTH +
  CHUNK_INDEX_LENGTH +
  CHUNK_TOTAL_COUNT_LENGTH +
  CHUNK_MESSAGE_TYPE_LENGTH +
  CHUNK_CLIENT_ID_LENGTH;

// Max size (in bytes) available for actual byte content within a single chunk
export const MAX_CHUNK_TOTAL_SIZE = MAX_PAYLOAD_SIZE - MESSAGE_HEADER_SIZE;
export const MAX_CHUNK_CONTENT_SIZE = MAX_CHUNK_TOTAL_SIZE - CHUNK_METADATA_HEADER_SIZE;